// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgStarHalfIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="m12 5.48 1.32 4.06.34 1.04h5.36l-3.46 2.51-.88.64.34 1.04 1.32 4.06-3.46-2.51-.88-.64zm0-2.62a1 1 0 0 0-.95.69l-1.8 5.53H3.44a1 1 0 0 0-.95.69c-.13.41.01.86.36 1.12l4.7 3.42-1.8 5.53c-.13.41.01.86.36 1.12.18.13.38.19.59.19s.41-.06.59-.19l4.7-3.42 4.7 3.42c.18.13.38.19.59.19s.41-.06.59-.19c.35-.25.5-.71.36-1.12l-1.8-5.53 4.7-3.42c.35-.25.5-.71.36-1.12a1 1 0 0 0-.95-.69h-5.81l-1.8-5.53a1 1 0 0 0-.95-.69z" />
  </g>
);
export default SvgStarHalfIcon;
SvgStarHalfIcon.displayName = 'SvgStarHalfIcon';
